console.log('Load: [emergency.js]');
/*!
 * jQuery-ajaxTransport-XDomainRequest - v1.0.2 - 2014-05-02
 * https://github.com/MoonScript/jQuery-ajaxTransport-XDomainRequest
 * Copyright (c) 2014 Jason Moon (@JSONMOON)
 * Licensed MIT (/blob/master/LICENSE.txt)
 */
(function(a){if(typeof define==='function'&&define.amd){define(['jquery'],a)}else{a(jQuery)}}(function($){if($.support.cors||!$.ajaxTransport||!window.XDomainRequest){return}var n=/^https?:\/\//i;var o=/^get|post$/i;var p=new RegExp('^'+location.protocol,'i');$.ajaxTransport('* text html xml json',function(j,k,l){if(!j.crossDomain||!j.async||!o.test(j.type)||!n.test(j.url)||!p.test(j.url)){return}var m=null;return{send:function(f,g){var h='';var i=(k.dataType||'').toLowerCase();m=new XDomainRequest();if(/^\d+$/.test(k.timeout)){m.timeout=k.timeout}m.ontimeout=function(){g(500,'timeout')};m.onload=function(){var a='Content-Length: '+m.responseText.length+'\r\nContent-Type: '+m.contentType;var b={code:200,message:'success'};var c={text:m.responseText};try{if(i==='html'||/text\/html/i.test(m.contentType)){c.html=m.responseText}else if(i==='json'||(i!=='text'&&/\/json/i.test(m.contentType))){try{c.json=$.parseJSON(m.responseText)}catch(e){b.code=500;b.message='parseerror'}}else if(i==='xml'||(i!=='text'&&/\/xml/i.test(m.contentType))){var d=new ActiveXObject('Microsoft.XMLDOM');d.async=false;try{d.loadXML(m.responseText)}catch(e){d=undefined}if(!d||!d.documentElement||d.getElementsByTagName('parsererror').length){b.code=500;b.message='parseerror';throw'Invalid XML: '+m.responseText;}c.xml=d}}catch(parseMessage){throw parseMessage;}finally{g(b.code,b.message,c,a)}};m.onprogress=function(){};m.onerror=function(){g(500,'error',{text:m.responseText})};if(k.data){h=($.type(k.data)==='string')?k.data:$.param(k.data)}m.open(j.type,j.url);m.send(h)},abort:function(){if(m){m.abort()}}}})}));

console.time('emergency');

var redirectURL = 'https://ontariotechu.ca/emergency';

var months = Array("January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December");

// add leading '0' to times in datetime stamp
function addZero(i) {
	if (i < 10) i = "0" + i;
	return i;
}


/**
 * EMERGENCY NOTIFICATION FEED
 * Alertus feed
 */

var emergencyfeed = 'https://inc.ontariotechu.ca/lib/emergency/emergency-feed.php';

jQuery.support.cors = true;

// @param url {string} url to parse
// @param parseXML {function} callback function
// @param dataType {string} data type
function loadXML(url, parseXML, dataType) {
	$.ajax({
		crossDomain: true,
		cache: true,
		url: url,
		type: 'GET',
		dataType: dataType,
		success: parseXML,
		error: loadXMLfail
	});
}

function loadXMLfail(xhr, status, error, url) {
	console.log("Error: Cannot process loadXML request. Error code = " + xhr.status + " " + xhr.statusText + ". URL: " + url);
}

function checkFeed(data) {
	if (Object.keys(data).length !== 0) parseEmergencyXML(data.title, data.description, data.pubDate);
	else noEmergencyXML();
}

function noEmergencyXML() {
	// clear window.name 
	window.name = '';

	// on emergency info page: clear message (set to default)
	if ($('#emergencyFeedMessage').length) {
		$('#emergencyFeedMessage').html('<p>There are no emergencies at Ontario Tech University at this time. <br>Local disruptions affecting the university can be found below or on the <a href="https://ontariotechu.ca/disruptions">service disruptions page</a>.</p>');
		$('#emergencyFeedMessage').removeClass('emergencyPresent');
	}

	// on all pages: remove alert bar
	if ($('#emergencyMessageBar').length) $('#emergencyMessageBar').remove();

	// on uoit.ca home page: show button on home page
	//if ($('#emergencyButton').length) $('#emergencyButton').show();
	
	// check notification xml
	loadXML(notificationxml, parseNotificationXML, 'xml')

}

function parseEmergencyXML(title, message, pubdate) {
	//console.log(window.name);
	var datetime;

	// set window.name on emergency info page
	if ($('#emergencyFeedMessage').length && (window.name != 'emergencyMessageReceived')) window.name = 'emergencyMessageReceived';

	// get feed first item node
	datetime = new Date(pubdate);
	datetime = months[datetime.getMonth()] + ' ' + datetime.getDate() + ', ' + datetime.getFullYear() + ' ' + addZero(datetime.getHours()) + ':' + addZero(datetime.getMinutes());


	/* REDIRECT ONCE: On all pages, except emergency info page (redirect if emergency page hasn't been viewed yet)
	---------------------------------------- */
	// if (!$('#emergencyFeedMessage').length && (window.name != 'emergencyMessageReceived')) window.location.href = redirectURL;  		  


	// EMERGENCY PAGE CONTENT MESSAGE
	// (On emergency info page)
	// ------------------------------
	if ($('#emergencyFeedMessage').length) {
		$('#emergencyFeedMessage').html('<p class="emergencyTitle">' + title + '</p><p class="emergencyDesc">' + message + '</p><p class="emergencyDate">' + datetime + '</p>');
		$('#emergencyFeedMessage').addClass('emergencyPresent');
	}


	// ALERT MESSAGE BAR
	// (On all pages)
	// ------------------
	if (!$('#emergencyMessageBar').length) {
		var alertBar = '<div id="emergencyMessageBar">' +
			'<a href="' + redirectURL + '">' +
			'<div class="row column padding">' +		
			'<div class="emergencyAlert">Emergency Alert</div>' +
			'<div class="emergencyMessage">' +
			'<p class="emergencyTitle"><strong>' + title + '</strong></p>' +
			'<p class="emergencyDesc">' + message + '</p>' +
			'<p class="emergencyDate">' + datetime + '</p>' +
			'</div>' +
			'</div>' +
			'</a>' +
			'</div>'; 
			
		// add after first link on page
		$('#btn_skip_to_content').after(alertBar);

		// hide button on home page
		if ($('#emergencyButton').length) $('#emergencyButton').hide();
	}
	// if item node exists and alert bar already displayed, just update message
	else {
		$('#emergencyMessageBar .emergencyTitle').text(title);
		$('#emergencyMessageBar .emergencyDesc').text(message);
		$('#emergencyMessageBar .emergencyDate').text(datetime);
	}

}

// check for emergency message on page load
var data;
loadXML(emergencyfeed, checkFeed, 'json');
// check for emergency message every 60 seconds
setInterval(function () {
	loadXML(emergencyfeed, checkFeed, 'json')
}, 60000); //60000



/**
 * NOTIFICATION FEED
 * CMS notification feed
 */

 var notificationxml = 'https://inc.ontariotechu.ca/lib/emergency/notification-feed.xml';

function parseNotificationXML(document) {
	$('channel', document).each(function () {
		if ($(this).children('item').length) {
			// get first item node
			$('item', document).each(function () {
				var title = $(this).children('title').text();
				var description = $(this).children('description').text();
				var content = $(this).children('content').text();
				var link = $(this).children('link').text();
				var pubdate = $(this).children('pubDate').text();
				var severity = $(this).children('severity').text();

				if (!$('#emergencyMessageBar').length) {
					var alertBar = '<div id="emergencyMessageBar" class="'+severity+'">' +
						'<a href="' + link + '?utm_source=emergencybar&utm_medium=emergencybar&utm_campaign='+title+'">' +
						'<div class="row align-middle padding">' +
						'<div class="emergencyAlert"><span>' + title + '</span>';
						if (description != '') {
							alertBar += '<p class="emergencyTitle">' + description + '</p>';
						}
						alertBar +=
							'</div>' +
							'<div class="emergencyMessage">';
						alertBar += (content != '') ? '<p>' + content + '</p>' : '<p class="emergencyTitle">' + description + '</p>';
						alertBar += '<p class="button hollow white tiny">Learn more</p>' +
							'</div>' +
						'</div>' +
						'</a>'
						'</div>';
					// add after first link on page
					$('#btn_skip_to_content').after(alertBar);
				}
				// if item node exists and alert bar already displayed, just update message
				else {
					$('#emergencyMessageBar .emergencyAlert span').text(title);
					$('#emergencyMessageBar .emergencyTitle').text(description);
					$('#emergencyMessageBar .emergencyMessage div').text(content);
					// $('#emergencyMessageBar span.emergencyDate').text(datetime);
				}
			});
			Foundation.reInit('sticky');
		}
		else {
			// on all pages: remove alert bar
			if ($('#emergencyMessageBar').length) $('#emergencyMessageBar').remove();
		}
	});

}



/**
 * NEWS SERVICE DISRUPTION FEED 
 * (Emergency info page only)
 */

var servicedisruptionsxml = 'https://news.ontariotechu.ca/topic/service_disruptions.xml' //servicetest.xml  

function parseServiceDisruptionsXML(document) {
	$('channel', document).each(function () {
		// check if item node exists
		if ($(this).children('item').length) {
			// add heading to page
			$('section.page-content').append('<div class="row column"><hr><h2>Service disruption news</h2></div>');

			// get news item nodes
			$('item', document).each(function () {
				var title = $(this).children('title').text();
				var image = $(this).children('media\\:content').first().attr('url');
				var imagealt = $(this).children('media\\:content').first().children('media\\:description').text();
				var link = $(this).children('link').text();
				var pubdate = $(this).children('pubDate').text();
				var datetime = new Date(pubdate);
				datetime = months[datetime.getMonth()] + ' ' + datetime.getDate() + ', ' + datetime.getFullYear() + ' ' + addZero(datetime.getHours()) + ':' + addZero(datetime.getMinutes());

				// format news item
				var newsItem = '<div class="emergencyNewsItem">' +
					'<a href="' + link + '" title="' + title + '"><img src="' + image + '" alt="' + imagealt + '" width="100" height="67"></a>' +
					'<p><strong><a href="' + link + '">' + title + '</strong></a></p>' +
					'<p class="date">' + datetime + '</p>' +
					'</div>';

				// add news item to page
				$('section.page-content').append(newsItem);
			});
		}
	});
}

// get service disruptions news feed if on emergency page
if ($('#emergencyFeedMessage').length) loadXML(servicedisruptionsxml, parseServiceDisruptionsXML, 'xml');

console.timeEnd('emergency');
